import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const SfQuestionmarkCircleFillIcon = props => /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 22 22",
  ...props,
  children: /*#__PURE__*/_jsx("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21.983 10.996c0 6.008-4.979 10.987-10.996 10.987C4.98 21.983 0 17.004 0 10.996 0 4.979 4.97 0 10.979 0c6.017 0 11.004 4.979 11.004 10.996ZM10 12.515c0 .506.279.768.768.768.49 0 .777-.304.777-.7v-.187c0-.65.354-1.046 1.156-1.586 1.105-.734 1.806-1.384 1.806-2.65 0-1.747-1.553-2.742-3.418-2.742-1.873 0-3.089.936-3.359 1.991-.05.169-.084.338-.084.523 0 .43.337.675.667.675.337 0 .557-.168.717-.413l.16-.236c.312-.726.97-1.216 1.84-1.216 1.097 0 1.806.608 1.806 1.494 0 .76-.448 1.156-1.46 1.857-.827.582-1.376 1.164-1.376 2.22v.202Zm-.354 2.945c0 .582.506 1.063 1.105 1.063.591 0 1.106-.473 1.106-1.063 0-.6-.506-1.072-1.106-1.072-.607 0-1.105.481-1.105 1.072Z",
    clipRule: "evenodd"
  })
});
export default SfQuestionmarkCircleFillIcon;